import { render, staticRenderFns } from "./patientContactList.vue?vue&type=template&id=3869b3c9&scoped=true"
import script from "./patientContactList.vue?vue&type=script&lang=js"
export * from "./patientContactList.vue?vue&type=script&lang=js"
import style0 from "./patientContactList.vue?vue&type=style&index=0&id=3869b3c9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3869b3c9",
  null
  
)

export default component.exports